import React from 'react';
import { DashboardLayout } from './components/DashboardLayout';
import { GlobalOverviewDashboard } from './components/global-overview';

export const dashboardRoutes = {
  path: '/dashboard',
  element: <DashboardLayout />,
  children: [
    {
      index: true,
      element: <GlobalOverviewDashboard />
    }
  ]
}; 